import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UltimatePagination from 'react-ultimate-pagination-bootstrap-3';

import {
  getDuplicatePropertiesPage,
  getDuplicatePropertiesPageCount
} from '../../store/selectors/duplicates';
import { retrieveDuplicates } from 'bundles/research/index/store/actions/duplicates';

export class DuplicatesPagination extends React.Component {
  static propTypes = {
    currentPage: PropTypes.number,
    totalPages: PropTypes.number,
    onPageChange: PropTypes.func
  };

  render() {
    const { currentPage, totalPages, onPageChange } = this.props;
    if (totalPages <= 1) return null;

    return (
      <div className="text-center">
        <UltimatePagination
          currentPage={currentPage}
          totalPages={totalPages}
          onChange={onPageChange}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  currentPage: getDuplicatePropertiesPage(state),
  totalPages: getDuplicatePropertiesPageCount(state)
});

const mapDispatchToProps = {
  onPageChange: retrieveDuplicates
};

export default connect(mapStateToProps, mapDispatchToProps)(DuplicatesPagination);
